// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Inventory from './pages/Inventory';
import Info from './pages/Info';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import ScrollToTop from './components/ScrollToTop';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import Service from './pages/Service';
import Finance from './pages/Finance';
import NewInventory from './pages/NewInventory';
import PreOwnedInventory from './pages/PreOwnedInventory';

const App: React.FC = () => {
  return (
    <ThemeConfig>
      <Router>
        <GlobalStyles />
        <Header />
        <ScrollToTop />
        <Routes>
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='/inventory'
            element={<Inventory />}
          />
          <Route
            path='/new-inventory'
            element={<NewInventory />}
          />
          <Route
            path='/pre-owned-inventory'
            element={<PreOwnedInventory />}
          />
          <Route
            path='/finance'
            element={<Finance />}
          />
          <Route
            path='/service'
            element={<Service />}
          />
          <Route
            path='/info/:id'
            element={<Info />}
          />
          <Route
            path='/terms'
            element={<TermsOfUse />}
          />
          <Route
            path='/privacy-policy'
            element={<PrivacyPolicy />}
          />

          <Route
            path='*'
            element={<NotFound />}
          />
        </Routes>
        <Footer />
      </Router>
    </ThemeConfig>
  );
};

export default App;
